import Repository from "@/repository";

export default {
    async fetchSearchResults(payload){
        return Repository.get(`${payload.path}`)
    }
}